// @ts-nocheck

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgLogin from "../assets/bg_login.png";
import logo_tlp from "../assets/logo_tlp.svg";
import PasswordInput from "../components/PasswordInput";
import api from "../services/api";
import useStore from "../store/useStore";
import LoggingService from "../services/LoggingService";
import { parseAuthToken } from "../utils/jwt";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { setUser } = useStore((state) => state);
  const navigate = useNavigate();

  // Função para tentar login com retry
  const attemptLogin = async (retryCount = 0) => {
    try {
      const response = await api.post("/login", { email, password });
      console.info("response-success", response);
      const { access_token } = response.data;

      localStorage.setItem("@tlp-authToken", access_token);
      const userData = parseAuthToken();

      if (userData) {
        setUser(userData);
        await LoggingService.logLogin();
        navigate("/home");
        return true;
      } else {
        throw new Error("Falha ao processar dados do usuário");
      }
    } catch (error) {
      console.error(`Erro ao fazer login (tentativa ${retryCount + 1}):`, error);

      // Se for erro 500 e ainda não tentamos uma segunda vez, tenta novamente
      if (error.response && error.response.status === 500 && retryCount === 0) {
        return false; // Indica que precisamos tentar novamente
      }

      // Se for erro de credenciais ou já tentamos duas vezes, mostra o erro
      if (error.response && error.response.status === 401) {
        setError("Email ou senha incorretos. Por favor, tente novamente.");
      } else if (retryCount > 0) {
        setError(
          "Erro ao conectar com o servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        setError("Ocorreu um erro inesperado. Por favor, tente novamente.");
      }

      return false;
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // Primeira tentativa
      const firstAttemptSuccess = await attemptLogin(0);

      // Se a primeira tentativa falhou com erro 500, tenta novamente
      if (!firstAttemptSuccess) {
        // Pequena pausa antes da segunda tentativa
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await attemptLogin(1);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${bgLogin})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div
        className="z-10 max-w-sm w-full bg-gray-500 rounded-md overflow-hidden
                      shadow-[0_0_15px_5px_rgba(249,115,22,0.4),0_0_25px_10px_rgba(253,186,116,0.2)]"
      >
        <div className="flex justify-start bg-gray-600 px-6 py-4 bg-">
          <img src={logo_tlp} alt="Logo" className="h-8 w-auto" />
          <div
            className="flex items-end font-tomorrow font-extrabold italic text-[#666666] text-xl 
          mb-[-6px] ml-[-2px]"
          >
            Radar
          </div>
        </div>
        <div className="p-6">
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-gray-700 text-sm font-bold mb-1"
              >
                E-mail
              </label>
              <input
                type="text"
                id="email"
                className="w-full px-3 py-2 border border-gray-300 rounded-md 
                    bg-beige 
                    text-gray-400
                    focus:outline-none focus:border-orange-100 focus:ring-1 focus:ring-orange-200
                    placeholder-gray-200 placeholder:italic placeholder:font-normal"
                placeholder="Seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="block text-gray-700 text-sm mb-1">
                Senha
              </label>
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isLoading}
              />
            </div>
            {error && <div className="text-red-500 text-sm mb-4">{error}</div>}
            <button
              type="submit"
              className="w-full border-2 border-blue-300 text-blue-300 text-md font-bold mt-4 py-2 px-4 
                        rounded-md hover:bg-blue-300 hover:text-gray-500 transition duration-300 
                        tracking-wider"
              disabled={isLoading}
            >
              {isLoading ? "Processando..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
